import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { axiosErr } from "@hilos/types/axios";
import { signup } from "../../helpers/session";
import useHilosStore from "../../hooks/useHilosStore";
import { buildRoute } from "../../router/router";
import { SignupForm } from "./SignupForm";

export default function Signup() {
  const navigate = useNavigate();
  const { loadSession } = useHilosStore();
  const [backendError, setBackendError] = useState("");
  const [backendValidationErrors, setBackendValidationErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const { t } = useTranslation();

  const addTrackingData = (formData) => {
    const trackingFields = [
      "utm_source",
      "utm_term",
      "utm_campaign",
      "utm_medium",
      "referral",
    ];
    trackingFields.forEach(
      (field) =>
        (formData[field] =
          localStorage.getItem(field) && localStorage.getItem(field) !== "null"
            ? localStorage.getItem(field)
            : "")
    );
  };

  const onSubmit = async (data) => {
    setBackendValidationErrors({});
    setBackendError("");
    setSuccess(false);
    setSubmitted(false);
    addTrackingData(data);

    try {
      const response = await signup(data);
      if (response) {
        setSuccess(true);
        setSubmitted(true);
        const user = await loadSession();

        if (user) {
          if (
            response.data.invitations &&
            response.data.invitations.length > 0
          ) {
            navigate(buildRoute("account-selection"));
          } else {
            setBackendError(
              t(
                "login:sign-up-account-restricted.title",
                "You have successfully signed up, but you need an invitation to join a team. Please contact your team administrator for an invitation."
              )
            );
            setSuccess(false);
            setSubmitted(false);
          }
        }
      }
    } catch (error) {
      const axiosErr = error as axiosErr;
      if (
        axiosErr?.response &&
        axiosErr.response.status === 400 &&
        axiosErr.response.data
      ) {
        setBackendValidationErrors(axiosErr.response.data);
      } else {
        setBackendError("An error occurred, please try again.");
      }
      setSuccess(false);
      setTimeout(() => {
        setSubmitted(false);
      }, 1000 * 2);
    }
  };

  return (
    <div className="flex flex-1 w-full flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
      <div className="mx-auto w-full ">
        <div className="text-center">
          <Trans i18nKey="login:sign-up.title">
            <h2 className="mt-6 text-lg font-extrabold text-gray-900">
              👋 Welcome to <span className="text-hilos">Hilos</span> !
            </h2>
          </Trans>
          <p className="text-2xl mt-4 text-gray-800 font-bold">
            {t(
              "login:sign-up.subtitle",
              "Close and onboard your customers on WhatsApp"
            )}
          </p>
        </div>

        <div className="mx-auto w-full max-w-md lg:w-96">
          <div className="mt-8">
            <div className="mt-6">
              <SignupForm
                onSubmit={onSubmit}
                backendError={backendError}
                backendValidationErrors={backendValidationErrors}
                success={success}
                submitted={submitted}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
